import { createAsyncThunk } from '@reduxjs/toolkit';
import { queryActions } from '../../..';
import store from '../../../..';
import { IApiaApiRequestConfig } from '../../../../../api/apiaApi/apiaApi';
import { buttonsActions } from '../../../../buttonsSlice';
import { TAsyncThunkState } from '../../../types';
import { TQueriesActionsChain } from '../../../queueController';

export type TRefreshData = {
  fieldId: string;
  url?: string;
  requestConfig?: IApiaApiRequestConfig<unknown>;
  pageNumber?: number;
  queryData?:
    | {
        workingMode: string;
      }
    // eslint-disable-next-line @typescript-eslint/ban-types
    | {};
  queueKey?: TQueriesActionsChain;
};

const refresh = createAsyncThunk<void, TRefreshData, TAsyncThunkState>(
  'querySlice/refresh',
  async ({ fieldId, queryData }) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );

    await store.dispatch(
      queryActions.search({
        fieldId,
        query: queryData,
        forceSearch: true,
        queueKey: 'fromRefresh',
      }),
    );

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );
  },
);

export default refresh;
